import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import EmptyButton from './EmptyButton';
import Anchor from './Anchor';
import AnchorLink from './AnchorLink';
import Icon from './Icon';

const styles = props => `
  color: ${props.theme.primary.normal};
  font-size: 16px;
  display: flex;
  align-items: center;
  font-weight: 600;
  width: 100%;
  text-align: left;
  line-height: 1.2;
  &:hover {
    i:last-child {
      transform: translateX(5px);
    }
  }
`;

const StyledButton = styled(EmptyButton)`
  ${styles}
`;

const StyledAnchor = styled(Anchor)`
  ${styles}
`;

const StyledAnchorLink = styled(AnchorLink)`
  ${styles}
`;

const MoreButton = ({ children, arrow, arrowAlign, ...props }) => {
  const types = useMemo(
    () => ({
      to: StyledAnchorLink,
      href: StyledAnchor,
      onClick: StyledButton,
    }),
    []
  );

  const type = useMemo(() => Object.keys(types).find(key => props[key]), [
    props,
    types,
  ]);

  const Button = types[type];

  return (
    <Button {...props}>
      {children}
      {arrow && (
        <Icon
          marginLeft={arrowAlign === 'right' ? 'auto' : '20px'}
          marginBottom="-1px"
          fontSize="32px"
          transition="all ease 0.3s"
          className="ls-icon icon-generalcaretrightmedium"
        />
      )}
    </Button>
  );
};

MoreButton.propTypes = {
  icon: PropTypes.node,
  children: PropTypes.node,
  arrow: PropTypes.bool,
  arrowAlign: PropTypes.string,
  onClick: PropTypes.func,
  to: PropTypes.string,
  href: PropTypes.string,
};

MoreButton.defaultProps = {
  icon: null,
  children: null,
  arrow: true,
  arrowAlign: 'left',
  onClick: () => {},
  to: null,
  href: null,
};

export default MoreButton;
